import script from "./SubpremisePrompt.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubpremisePrompt.vue?vue&type=script&setup=true&lang=ts"

import "./SubpremisePrompt.vue?vue&type=style&index=0&id=0a5cf14e&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a5cf14e"]])

export default __exports__